export interface EventDateRangeInput {
  date: string;
  heure: string;
  dateFin?: string | null;
  heureFin?: string | null;
}

function toDate(date: string, time: string) {
  return new Date(`${date}T${time}:00`);
}

function formatWeekday(value: Date) {
  return value.toLocaleDateString("fr-FR", { weekday: "long" });
}

function formatFullDate(value: Date) {
  return value.toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric"
  });
}

function formatShortDate(value: Date) {
  return value.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
}

function formatTime(value: string) {
  return value.replace(":", "h");
}

export function formatEventDateTimeRange(event: EventDateRangeInput) {
  const start = toDate(event.date, event.heure);
  const endDate = event.dateFin || event.date;
  const endTime = event.heureFin || event.heure;
  const hasEnd = Boolean(event.dateFin || event.heureFin);

  if (!hasEnd) {
    return `${formatFullDate(start)} à ${formatTime(event.heure)}`;
  }

  if (endDate === event.date) {
    return `${formatFullDate(start)} de ${formatTime(event.heure)} à ${formatTime(endTime)}`;
  }

  return `Du ${formatFullDate(start)} à ${formatTime(event.heure)} au ${formatFullDate(toDate(endDate, endTime))} à ${formatTime(endTime)}`;
}

export function formatEventScheduleLine(event: EventDateRangeInput) {
  const start = toDate(event.date, event.heure);
  const endDate = event.dateFin || event.date;
  const endTime = event.heureFin || event.heure;
  const hasEnd = Boolean(event.dateFin || event.heureFin);

  if (!hasEnd) {
    return `${formatWeekday(start)} à ${formatTime(event.heure)}`;
  }

  if (endDate === event.date) {
    return `${formatWeekday(start)} de ${formatTime(event.heure)} à ${formatTime(endTime)}`;
  }

  return `Du ${formatShortDate(start)} ${formatTime(event.heure)} au ${formatShortDate(toDate(endDate, endTime))} ${formatTime(endTime)}`;
}
